import { Fragment } from "react";
import { useFormContext } from "react-hook-form";

import Select from "~/common/components/ui/select/Select";
import {
  questionTypeOptions,
  questionTypeToFieldsMap,
} from "~/providers/constants/supplementalQuestions";
import {
  AddQuestionForm,
  SupplementalQuestionTypes,
} from "~/providers/types/supplementalQuestions";
import { getDefaultValuesForSupplementalQuestionType } from "~/providers/utils/supplementalQuestions";

export const SupplementalQuestionUpsertForm = ({
  isEdit,
}: {
  isEdit?: boolean;
}) => {
  const form = useFormContext<AddQuestionForm>();

  const selectedType = form.watch("type");
  const DynamicFields = selectedType
    ? questionTypeToFieldsMap[selectedType]
    : null;

  return (
    <div className="flex flex-col gap-6">
      <Select
        id="type"
        label="Question type"
        placeholder="Select question type"
        options={questionTypeOptions}
        control={form.control}
        isDisabled={!!isEdit}
        error={form.formState.errors.type?.message}
        onChange={(newType) => {
          const defaults = getDefaultValuesForSupplementalQuestionType(
            newType as SupplementalQuestionTypes,
          );
          form.reset(defaults);
        }}
      />

      {DynamicFields && (
        <Fragment>
          <div className="border-b border-neutral-700" />
          <DynamicFields />
        </Fragment>
      )}
    </div>
  );
};
